import React, { useState, useEffect } from "react";
import validator from "validator";
import axios from "axios";
import { useAuth } from "../contexts/auth";
import { postEditPaymentURL } from "../utils/api";
import {
    Flex,
    Spacer,
    Button,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    FormControl,
    FormLabel,
    FormErrorMessage,
    FormHelperText,
    Input,
    Text,
    RadioGroup,
    Radio,
    HStack,
    Box,
    InputRightElement,
    useColorModeValue,
  } from "@chakra-ui/react";

function EditPayment({
    isOpen,
    onClose,
    successCallback,
    paymentData,
}) {
    const textColor = useColorModeValue("gray.700", "white");   

    if (paymentData == null) {
        return (<></>);
    }

    const [ type, setType ] = useState('Cash');
    const [ amount, setAmount ] = useState('0');
    const [ bank, setBank ] = useState(null);
    const [ referenceNumber, setReferenceNumber ] = useState(null);
    const [ accountNumber, setAccountNumber ] = useState(null);
    const [ accountName, setAccountName ] = useState(null);
    const [ chequeNumber, setChequeNumber ] = useState(null);

    const [ invAmount, setInvAmount ] = useState(null);
    const [ invBank, setInvBank ] = useState(null);
    const [ invReferenceNumber, setInvReferenceNumber ] = useState(null);
    const [ invAccountNumber, setInvAccountNumber ] = useState(null);
    const [ invAccountName, setInvAccountName ] = useState(null);
    const [ invChequeNumber, setInvChequeNumber ] = useState(null);

    const { auth } = useAuth();
    const [ errors, setErrors ] = useState([]);
    const [ submitting, setSubmitting ] = useState(false);

    const postPayments = (e) => {
        e.preventDefault();

        let id;
        if (paymentData) {
            id = paymentData.id;
        }

        setSubmitting(true);
        // console.log(email, password);
        axios.post(postEditPaymentURL(id), {
            type,
            bank: type == 'Online'
                ? bank : undefined,
            referenceNumber: type == 'Online'
                ? referenceNumber: undefined,
            accountNumber: type == 'Cheque'
                ? accountNumber: undefined,
            accountName: type == 'Cheque'
                ? accountName: undefined,
            chequeNumber: type == 'Cheque'
                ? chequeNumber: undefined,
            amount,
        },{
            headers: {
                Authorization: `Bearer ${auth.authToken}`
            }
        }).then(result => {
            if (result.status === 200) {
                // const roles = result.data.data.user.roles;
                const user = result.data.data;
                // console.log(user);
                if (successCallback) {
                    successCallback();
                }
                setType('Cash');
                setBank(null);
                setReferenceNumber(null);
                setAccountName(null);
                setAccountNumber(null);
                setChequeNumber(null);
                setAmount('0');
                
                onClose();
            } else {
                setErrors(result.data.errors);
            }
        }).catch(e => {
            if (e.response === undefined) {
                setErrors(['Could not connect to server!'])
            } else {
                setErrors(e.response.data.errors)
            }
        }).finally(e => {
            setSubmitting(false);
        });
    }

    useEffect(() => {

        if (!validator.isEmpty(amount)) {
            setInvAmount(!validator.isNumeric(amount));
        }
        

    }, [amount]);


    useEffect(() => {

        if (isOpen && paymentData) {
            // console.log(paymentData);
            setType(paymentData.type);
            setBank(paymentData.bank ?? null);
            setReferenceNumber(paymentData.referenceNumber ?? null);
            setAccountName(paymentData.accountName ?? null);
            setAccountNumber(paymentData.accountNumber ?? null);
            setChequeNumber(paymentData.chequeNumber ?? null);
            setAmount(paymentData.amount.toString());
            setErrors([]);
        }

    }, [isOpen, paymentData]);

    if (!paymentData) {
        return (<></>);
    }

    return (
        <Modal isOpen={isOpen} onClose={onClose} size="lg">
            <ModalOverlay />
            <ModalContent>
            <ModalHeader>Update Order Payment</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
                <form onSubmit={postPayments}>
                    <FormControl >
                        {/* Payment Type */}
                        <RadioGroup 
                            defaultValue={paymentData.type} 
                            mb="12px" 
                            onChange={setType}
                            mt="18px"
                            // value={type}
                        >
                            <HStack spacing="24px">
                                <Radio value="Cash">Cash</Radio>
                                <Radio value="Online">Online</Radio>
                                <Radio value="AccountsReceivable">Accounts Receivable</Radio>
                                <Radio value="Cheque">Cheque</Radio>
                            </HStack>
                        </RadioGroup>


                        <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                            Amount
                        </FormLabel>
                        <Input
                            borderRadius="15px"
                            mb="12px"
                            fontSize="sm"
                            type="number"
                            placeholder="10000"
                            size="md" 
                            min={1}
                            max={parseFloat(paymentData.total) - parseFloat(paymentData.paymentsTotal)}
                            isInvalid={invAmount === true}
                            isRequired={true}
                            value={amount} 
                            onChange={e => setAmount(e.target.value)}
                        />
                        
                        { type == 'Online'
                            ? <Box pr="12px">
                                <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                                    Bank / E-Wallet
                                </FormLabel>
                                <Input
                                    borderRadius="15px"
                                    mb="12px"
                                    fontSize="sm"
                                    type="text"
                                    placeholder="Bank / E-Wallet Name"
                                    size="md" 
                                    isInvalid={invBank === true}
                                    isRequired={true}
                                    value={bank} 
                                    onChange={e => setBank(e.target.value)}
                                />
                            </Box>
                            : null 
                        }
                        

                        { type == 'Online'
                            ? <Box pr="12px">
                                <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                                    Reference / Transaction Number
                                </FormLabel>
                                <Input
                                    borderRadius="15px"
                                    mb="12px"
                                    fontSize="sm"
                                    type="text"
                                    placeholder="Reference / Transaction Number"
                                    size="md" 
                                    isInvalid={invReferenceNumber === true}
                                    isRequired={true}
                                    value={referenceNumber} 
                                    onChange={e => setReferenceNumber(e.target.value)}
                                />
                            </Box>
                            : null 
                        }

                        { type == 'Cheque'
                            ? <Box pr="12px">
                                <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                                    Account Number
                                </FormLabel>
                                <Input
                                    borderRadius="15px"
                                    mb="12px"
                                    fontSize="sm"
                                    type="text"
                                    placeholder="Account Number"
                                    size="md" 
                                    isInvalid={invAccountNumber === true}
                                    isRequired={true}
                                    value={accountNumber} 
                                    onChange={e => setAccountNumber(e.target.value)}
                                />
                            </Box>
                            : null 
                        }

                        { type == 'Cheque'
                            ? <Box pr="12px">
                                <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                                    Account Name
                                </FormLabel>
                                <Input
                                    borderRadius="15px"
                                    mb="12px"
                                    fontSize="sm"
                                    type="text"
                                    placeholder="Account Name"
                                    size="md" 
                                    isInvalid={invAccountName === true}
                                    isRequired={true}
                                    value={accountName} 
                                    onChange={e => setAccountName(e.target.value)}
                                />
                            </Box>
                            : null 
                        }

                        { type == 'Cheque'
                            ? <Box pr="12px">
                                <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                                    Cheque Number
                                </FormLabel>
                                <Input
                                    borderRadius="15px"
                                    mb="12px"
                                    fontSize="sm"
                                    type="text"
                                    placeholder="Cheque Number"
                                    size="md" 
                                    isInvalid={invChequeNumber === true}
                                    isRequired={true}
                                    value={chequeNumber} 
                                    onChange={e => setChequeNumber(e.target.value)}
                                />
                            </Box>
                            : null 
                        }
                        
                        
                        
                        <Flex w="100%" flexDir="column">
                            { errors.length > 0 && <Text color="red">{errors[0]}</Text> }
                        </Flex>
                        <Button
                            fontSize="10px"
                            type="submit"
                            bg="teal.300"
                            w="100%"
                            h="45"
                            mb="20px"
                            color="white"
                            mt="0px"
                            _hover={{
                            bg: "teal.200",
                            }}
                            _active={{
                            bg: "teal.400",
                            }}
                            isDisabled={submitting}
                        >
                            UPDATE
                        </Button>
                    </FormControl>
                </form>
            </ModalBody>
            </ModalContent>
        </Modal>
    );

}



export default EditPayment;
